import React from 'react';
import brochurePdf from '../Resources/sala-e-brochure.pdf';
import '../Styles/BrochureBadge.css';

const BrochureBadge = () => {
    const [hidden, setHidden] = React.useState(false);

    React.useEffect(() => {
        const handleScroll = () => {
            // Hide when scrolling past viewport height
            const shouldHide = window.scrollY >= window.innerHeight;
            setHidden(shouldHide);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <a
            href={brochurePdf}
            download="Sala_Brochure.pdf"
            className={`brochure-badge ${hidden ? 'brochure-hidden' : ''}`}
        >
            DOWNLOAD BROCHURE
        </a>
    );
};

export default BrochureBadge;
